import type { QuestionnaireState } from "../../types";

export const handleSetAsyncErrorAction = (
  state: QuestionnaireState,
  payload: { name: string; message: string },
): QuestionnaireState => {
  return {
    ...state,
    asyncErrors: {
      ...state.asyncErrors,
      [payload.name]: payload.message,
    },
  };
};
